import AccordionTabs from './shared/responsiveAccordionTabs';

export default {
  init(store, domEl) {
    const sideContentArticleNode = document.getElementById('policies-component__article');

    const setSideContent = html => {
      sideContentArticleNode.innerHTML = html;
    };

    const handleToggle = toggler => {
      const isExpanded = toggler.getAttribute('aria-expanded') === 'true';
      const controlsId = toggler.getAttribute('aria-controls');
      const content = domEl.querySelector(`#${controlsId} .policy-tab__content`).innerHTML;
      isExpanded ? setSideContent(content) : setSideContent('');
    };

    return new AccordionTabs({ container: domEl, onToggle: handleToggle });
  },
};
